import { MessageBus, Event } from '@podium/browser';
import diagnostics from '../utils/diagnostics';

let messageBus: MessageBus;

export function peek(channel: string, topic: string): Event | void {
    if (!messageBus) {
        messageBus = new MessageBus();
    }
    messageBus.peek(channel, topic);
}
export function unsubscribe(
    channel: string,
    topic: string,
    callback: (event: Event) => void,
) {
    if (!messageBus) {
        messageBus = new MessageBus();
    }
    messageBus.unsubscribe(channel, topic, callback);
}
export function subscribe(
    channel: string,
    topic: string,
    callback: (event: Event) => void,
) {
    if (!messageBus) {
        messageBus = new MessageBus();
    }

    messageBus.subscribe(channel, topic, callback);

    const eventFromBeforeSubscription = messageBus.peek(channel, topic);

    if (eventFromBeforeSubscription) {
        diagnostics(
            'Message waiting on app init %c%s - %s',
            'font-weight: bold;',
            eventFromBeforeSubscription.channel,
            eventFromBeforeSubscription.topic,
            eventFromBeforeSubscription.payload,
        );
        callback(eventFromBeforeSubscription);
    }
}

export function publish(channel: string, topic: string, payload?: unknown) {
    if (!messageBus) {
        messageBus = new MessageBus();
    }
    diagnostics(
        'Publishing message %c%s - %s',
        'font-weight: bold;',
        channel,
        topic,
        payload,
    );
    messageBus.publish(channel, topic, payload);
}
